












































/** @format */

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';

@Component
export default class EditableTree extends Vue {
  // 源数据
  @Prop({ default: [] })
  dataSource!: any[];
  // 是否可编辑树
  @Prop({ default: false })
  editable!: boolean;
  // 在树可编辑的情况下，是否可添加节点
  @Prop({ default: true })
  canAddNode!: boolean;
  // 在树可编辑的情况下，是否可编辑节点
  @Prop({ default: true })
  canEditNode!: boolean;
  // 在树可编辑的情况下，是否可删除节点
  @Prop({ default: true })
  canDeleteNode!: boolean;
  // 在canAddNode为true时，禁止添加的节点id数组
  @Prop({ default: () => [] })
  disableAddIds!: string[];
  // 在canEditNode为true时，禁止编辑的节点id数组
  @Prop({ default: () => [] })
  disableEditIds!: string[];
  // 在canDeleteNode为true时，禁止删除的节点id数组
  @Prop({ default: () => [] })
  disableDeleteIds!: string[];
  // 需要高亮文本的节点id数组
  @Prop({ default: () => [] })
  highlightTextIds!: string[];

  /**
   *
   */
  @Prop({ default: true })
  defaultExpandAll!: boolean;

  defaultExpandedArray: any[] = [];
  treeData: any[] = [];
  // 选中的节点key
  selectedKey: string = '';

  @Watch('dataSource', { immediate: true, deep: true })
  onDataSourceChanged(newData: any[]) {
    this.treeData = cloneDeep(newData);
    if (this.editable) {
      this.handleEditableTreeData(this.treeData);
    }
  }

  /**
   * 将树数据处理为可编辑数据
   * @param treeData
   */
  handleEditableTreeData(treeData: any[]) {
    treeData.forEach(item => {
      if (item.scopedSlots) {
        item.scopedSlots['title'] = 'titleRender';
      } else if (item.slots) {
        item.slots['title'] = 'titleRender';
      } else {
        item.scopedSlots = {
          title: 'titleRender'
        };
      }
      if (Array.isArray(item.children) && item.children.length > 0) {
        this.handleEditableTreeData(item.children);
      }
    });
  }

  /**
   * 选择树节点
   */
  onSelectNode(...params) {
    let orgDepType = '';
    if (typeof this.$listeners.select === 'function') {
      this.$listeners.select(...params);
    } else {
      this.selectedKey = params[0][0];
      orgDepType = params[1].node.$vnode.data.props.orgDepType;
    }

    this.$emit('selectNode', {
      node: this.selectedKey,
      orgDepType: orgDepType
    });
  }

  created() {
    const [first = {}] = this.treeData;

    if (!this.defaultExpandAll && first && first.value) {
      this.defaultExpandedArray = [first.value];
    }
  }
}
